import InputText, { InputTextProps } from "app/components/FormInput/InputText";
import React, { ReactNode, useEffect, useState } from "react";
import "./CustomInput.css";

interface CustomInputProps extends InputTextProps {
    placeholderCustom?: ReactNode;
    rules?: {
        required?: boolean
        regex?: RegExp;
        errorMessage: string;
    }[];
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const CustomInput: React.FC<CustomInputProps> = ({ onBlur, placeholderCustom, rules, onChange, ...props }) => {
    const [isValid, setIsValid] = useState(true);
    const [errorMessage, setErrorMessage] = useState("");

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;

        if (rules && rules.length > 0) {
            for (const rule of rules) {
                if (rule?.required) {
                    if (!!value) {
                        setIsValid(false);
                        setErrorMessage(rule.errorMessage);
                    }
                }
                if (rule?.regex && !rule?.regex.test(value) && value) {
                    setIsValid(false);
                    setErrorMessage(rule.errorMessage);
                    break;
                } else {
                    setIsValid(true);
                    setErrorMessage("");
                }
            }
        }

        if (onChange) {
            onChange(e);
        }
    };

    const handleBlur = (e) => {
        const value = e.target.value;

        if (rules && rules.length > 0) {
            for (const rule of rules) {
                if (!!rule?.required && !value) {
                    setIsValid(false);
                    setErrorMessage(rule.errorMessage);
                }
            }
        }

        if (onBlur) {
            onBlur(e);
        }
    }

    return (
        <div style={{ width: "100%", border: 0 }} >
            <div className="ant-input-affix-wrapper" style={{ width: "100%", border: 0, padding: 0 }}>
                <InputText
                    {...props}
                    value={props.value}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className="custom-input"
                    style={{
                        border: "none",
                        borderBottom: `1px solid ${isValid ? "#C1C1C1" : "red"}`,
                        width: "100%",
                        lineHeight: "39px",
                    }}
                />
                <span
                    style={{
                        position: "absolute",
                        left: 10,
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#bfbfbf",
                        pointerEvents: "none",
                    }}
                >
                    <span style={{ display: props.value ? 'none' : 'flex', justifyContent: 'center', alignItems: 'center' }}>{placeholderCustom}</span>
                </span>
            </div>

            {!isValid && errorMessage && (
                <p className={`error-message ${!isValid ? "fade-in" : ""}`}>
                    {errorMessage}
                </p>
            )}
        </div>
    );
};

export default CustomInput;
